export const DELETE_CATEGORIES = "DELETE_CATEGORIES";
export const deleteCategoriesAction = (categories) => {
    return {
        type: "DELETE_CATEGORIES",
        payload: categories
    }
}

export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const fetchCategoriesAction = (categories) => {
    return {
        type: "FETCH_CATEGORIES",
        payload: categories
    }
}

export const INIT_CATEGORIES = "INIT_CATEGORIES";
export const initCategoriesAction = () => {
    return {
        type: "INIT_CATEGORIES",
        payload: null
    }
}
